import { useEffect } from 'react';

/**
 * v3.91.0 — a signed-in user means the second factor is done: never leave the
 * MFA code screen over the app. It happens when a trusted computer's answer
 * lands after its timeout (the code screen had already taken over), or any
 * other late sign-in. `close` clears the code screen's state.
 */
export default function useCloseMfaOnSignIn(user, mfaOpen, close) {
  useEffect(() => {
    if (user && mfaOpen) close();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, mfaOpen]);
}
